import { useQuery } from '@office-start/data-fetching';
import { executeRecommendedConfigDataFlow } from '../executeRecommendedConfigDataFlow';
//eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useRecommendedConfig() {
    var queryKey = ['RecommendedConfig'];
    return useQuery(queryKey, function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return executeRecommendedConfigDataFlow();
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
    });
}
//# sourceMappingURL=useRecommendedConfig.js.map